// extracted by precise-mini-css-extract-plugin
export default {"PopoverCloseButton":"PopoverCloseButton_PopoverCloseButton--4bZp8Kht"};